<!-- A toggle reads better as a checkbox row than as a labelled field. -->
<!-- "Show only rows where": one row per rule — a column dropdown and the
     values to keep (any of them). Several rules = every one must match.
     Without loaded columns it stays the plain text box below. -->
<div class="dsg-row-filter" *ngIf="isRowFilter(); else toggleOrField">
  <span class="dsg-row-filter-title" [matTooltip]="tooltip()">{{ control().label }}</span>
  <div class="dsg-row-filter-rule" *ngFor="let rule of rowRules(); let i = index; trackBy: trackByIndex">
    <ng-select
      #ruleCol
      class="ss-select"
      [class.is-open]="!!ruleCol.isOpen()"
      appendTo="body"
      ngClass="ss-dropdown-panel"
      [items]="columnOptions()"
      bindLabel="label"
      bindValue="value"
      [clearable]="false"
      [searchable]="true"
      placeholder="Column"
      [ngModel]="rule.field"
      (ngModelChange)="setRuleField(i, $event)"
    ></ng-select>
    <ng-select
      #ruleVals
      class="ss-select"
      [class.is-open]="!!ruleVals.isOpen()"
      appendTo="body"
      ngClass="ss-dropdown-panel"
      [items]="rowValueOptions(rule.field, rule.values)"
      [multiple]="true"
      [closeOnSelect]="false"
      [addTag]="addRowValue"
      [searchable]="true"
      placeholder="Values to show"
      [ngModel]="rule.values"
      (ngModelChange)="setRuleValues(i, $event)"
    ></ng-select>
    <button type="button" class="dsg-row-filter-remove" title="Remove" aria-label="Remove rule" (click)="removeRule(i)">×</button>
  </div>
  <button type="button" class="dsg-row-filter-add" (click)="addRule()">+ Add rule</button>
  <small class="dsg-row-filter-hint" *ngIf="!rowRules().length">No rule: every row shows.</small>
</div>

<ng-template #toggleOrField>
<label class="dsg-check" *ngIf="kind() === 'toggle'; else fieldControl">
  <input type="checkbox" [ngModel]="boolValue()" (ngModelChange)="emit($event)" />
  <span>{{ control().label }}</span>
</label>
</ng-template>

<ng-template #fieldControl>
  <!-- Free-text controls (endpoints, labels, messages) stack the label above
       a full-width box: side by side, a long label left only a sliver for the
       value and the box scrolled to the end of a URL. -->
  <label class="dsg-field dsg-field-wide" [class.dsg-field-stacked]="stacked()" [class.dsg-field-half]="half()" [class.dsg-field-picker]="isColumnSelect()" [ngSwitch]="kind()">
    <!-- Hover shows the control's hint; a long label (likely clipped) shows
         itself. A short label gets no tooltip, which only repeated it. -->
    <span [matTooltip]="tooltip()">{{ control().label }}</span>

    <!-- ng-select, not a native <select>: option labels come from the chart
         config JSON and can be long; a native popup spilled past the panel.
         The panel keeps the control's width; the hover tooltip shows a
         clipped label. -->
    <ng-select
      *ngSwitchCase="'select'"
      #controlSel
      class="ss-select"
      [class.is-open]="!!controlSel.isOpen()"
      appendTo="body"
      ngClass="ss-dropdown-panel"
      [items]="selectOptions()"
      bindLabel="label"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      [ngModel]="value()"
      (ngModelChange)="emit($event)"
    ></ng-select>

    <!-- One of the widget's own columns, as a single-row dropdown like the
         other selects; clearing it means "none / default". With no columns
         to offer it is a plain text box instead. -->
    <ng-container *ngSwitchCase="'column-select'">
      <!-- The frame holds the dropdown and OUR clear button beside it. ng-select's
           own × is off: its mousedown handling opened the list instead of
           clearing when the × glyph itself was pressed. The button is a plain
           click outside ng-select, so nothing can reopen the list or keep the
           value. (click) preventDefault on the picker: the row is a <label>,
           which would otherwise forward a click to the picker's input. -->
      <span class="dsg-picker" *ngIf="isColumnSelect(); else columnText" [class.has-value]="!!value()">
        <ng-select
          #columnSel
          class="ss-select"
          [class.is-open]="!!columnSel.isOpen()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="columnOptions()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="true"
          [placeholder]="control().placeholder ?? 'None'"
          [ngModel]="value() || null"
          (ngModelChange)="emit($event ?? '')"
          (click)="$event.preventDefault()"
        ></ng-select>
        <button
          *ngIf="value()"
          type="button"
          class="dsg-picker-clear"
          title="Clear"
          aria-label="Clear"
          (mousedown)="$event.preventDefault(); $event.stopPropagation()"
          (click)="$event.preventDefault(); $event.stopPropagation(); clearPicker(columnSel)"
        >×</button>
      </span>
      <ng-template #columnText>
        <input type="text" [placeholder]="control().placeholder ?? ''" [ngModel]="textValue()" (ngModelChange)="emit($event)" />
      </ng-template>
    </ng-container>

    <input
      *ngSwitchCase="'number'"
      type="number"
      [min]="min()"
      [max]="max()"
      [step]="step()"
      [ngModel]="numberValue()"
      (ngModelChange)="emitNumber($event)"
    />

    <input
      *ngSwitchCase="'color'"
      type="color"
      [ngModel]="colorValue()"
      (ngModelChange)="emit($event)"
    />

    <input
      *ngSwitchDefault
      type="text"
      [placeholder]="control().placeholder ?? ''"
      [ngModel]="textValue()"
      (ngModelChange)="emit($event)"
    />
  </label>
</ng-template>
